import { Outlet, useLocation } from 'react-router-dom'
import { useIsSmallScreen } from '@/common/ui/useIsSmallScreen'
import { H1 } from '@/common/ui/h1'
import AccountTabs from './components/AccountTabs'
import MobileTabMenu from './components/MobileTabMenu'
import AccountSupportCard from './components/AccountSupportCard'
import { useCurrentAccount } from '../useCurrentAccount'
import { showMessages } from '@intercom/messenger-js-sdk'
import { getAccountPageTabFromPathname, isAccountPageEditingRoute } from '@/common/navigation/accountRoutes'
import { NAVIGATION_COPY } from '@/locales/en'

export const AccountContainer = () => {
    const location = useLocation()
    const isSmallScreen = useIsSmallScreen(768)
    const account = useCurrentAccount()

    const activeTab = getAccountPageTabFromPathname(location.pathname)
    const isEditing = isAccountPageEditingRoute(location.pathname)
    const isMenuOpen = isSmallScreen && location.pathname === '/account'

    const handleContactSupport = () => {
        try {
            showMessages()
        } catch {
            // Ignore Intercom SDK availability issues
        }
    }

    const showSupportCard = !isMenuOpen && !isEditing && activeTab !== 'settings'

    if (!account) {
        return null
    }

    return (
        <div
            className={`self-stretch pb-20 w-full bg-white rounded-tl-lg rounded-tr-lg inline-flex flex-col justify-start items-center gap-8 md:gap-12 ${
                isEditing ? 'min-h-[calc(var(--vh,1vh)*100-7.5rem)]' : ''
            }`}
        >
            {!isEditing && (
                <>
                    <div className="self-stretch flex flex-col justify-start items-start gap-6 md:gap-8">
                        {(!isSmallScreen || isMenuOpen) && (
                            <H1 className="leading-10 mb-0">{NAVIGATION_COPY.account.pageTitle}</H1>
                        )}

                        <div className="hidden md:flex self-stretch flex-col justify-start items-start gap-12">
                            <AccountTabs accountType={account?.accountType} />
                            <div className="self-stretch flex flex-col justify-start items-start gap-12">
                                <Outlet />
                            </div>
                        </div>

                        <div className="md:hidden self-stretch flex flex-col justify-start items-start gap-6">
                            {isMenuOpen ? (
                                <MobileTabMenu accountType={account?.accountType} />
                            ) : (
                                <div className="self-stretch flex flex-col justify-start items-start gap-8 md:px-6">
                                    <Outlet />
                                </div>
                            )}
                        </div>
                    </div>

                    {showSupportCard && (
                        <div className="self-stretch px-0">
                            <AccountSupportCard onContactSupport={handleContactSupport} />
                        </div>
                    )}
                </>
            )}

            {isEditing && <Outlet />}
        </div>
    )
}
